import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';

import { Documents } from '../models/official-documents.model';
import { OfficialDocumentsRepository } from '../repositories/official-documents.repository';

export class StoreDocumentsDataUseCase implements UseCase<Documents, boolean> {
    constructor(private readonly repository: OfficialDocumentsRepository) {}

    execute(documentsData: Documents): Observable<boolean> {
        return this.repository.storeDocuments(documentsData);
    }
}
